import Swiper, { Navigation, Pagination, FreeMode, Autoplay } from 'swiper';
Swiper.use([Navigation, Pagination, FreeMode, Autoplay]);

function newsSlider() {
	const newsSliders = document.querySelectorAll( '.js-news-slider' )

	if ( newsSliders.length > 0 ) {
		newsSliders.forEach(element => {
			const newsSlider = new Swiper(element, {
				observer: true, 
				observeParents: true,
				loop: true,
				draggable: true,
				freeMode: {
					enabled: true,
					sticky: true,
				},
				allowTouchMove: true,
				effect: 'slide',
				spaceBetween: 20,
				slidesPerView: 1,
				breakpoints: {
					760: {
					slidesPerView: 2,
					spaceBetween: 20
					},
					992: {
					slidesPerView: 2,
					spaceBetween: 20
					},
				},
				navigation: {
						nextEl: '.js-news-slider-next',
						prevEl: '.js-news-slider-prev',
					},
				watchSlidesVisibility: true,
				watchSlidesProgress: true,
			});
			
			$('.js-news-slider').find('.swiper-slide-prev').css( 'visibility', 'hidden' );
			
			newsSlider.on('slideChange', function(){
				$('.js-news-slider').find('.swiper-slide').css( 'visibility', '' );
			});
		});
	}
}

export default newsSlider;
